import { useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'

import Button from '../components/Button'
import GridHeader from '../components/GridHeader'
import ButtonDownload from '../components/ButtonDownload'
import SelectionBar from '../components/selection/SelectionBar'
import TableCellRuolo from '../components/table/TableCellRuolo'
import TableCellSesso from '../components/table/TableCellSesso'
import SortableTableHead from '../components/SortableTableHead'
import GridCircularProgress from '../components/GridCircularProgress'
import DialogUploadTesserati from '../components/DialogUploadTesserati'
import { config } from '../settings/configs'
import { colours } from '../settings/settings'
import {
  useGetAffiliazioniLightQuery,
  useGetTesseratiQuery,
} from '../hooks/api-slice'
import { selectTesseratiSorted } from '../store/selectors'

const Tesserati = () => {
  const { admin, codiceUtente } = useSelector(state => state.home.infoUtente)
  const { data: affiliazioniLight } = useGetAffiliazioniLightQuery(undefined, {
    skip: !admin,
  })

  const selectedStagione = useSelector(
    state => state.selection.selectedStagione,
  )
  const selectedSocieta = useSelector(state => state.selection.selectedSocieta)
  const availableTessere = useSelector(
    state => state.selection.availableTessere,
  )
  const selectedTessera = useSelector(state => state.selection.selectedTessera)

  const tArgs = { admin, stagione: selectedStagione, codiceUtente }
  const tSkip = !(selectedStagione && (admin || codiceUtente))
  const tesserati = useSelector(state => selectTesseratiSorted(state, tArgs))
  const { isFetching } = useGetTesseratiQuery(tArgs, { skip: tSkip })

  const tesseratiN = tesserati
    ?.filter(t =>
      admin && selectedSocieta
        ? t.codiceSocieta ===
          affiliazioniLight?.find(a => a.id === selectedSocieta)?.codiceSocieta
        : true,
    )
    ?.filter(
      t =>
        !selectedTessera ||
        selectedTessera === availableTessere[0] ||
        selectedTessera === t.ruolo,
    )

  document.title = `${config?.name} - Tesserati`

  let columns = [
    { label: 'Sesso', sortable: false },
    { label: 'Nome', sortable: true, sortingField: 'cognomenome' },
    { label: 'Data di nascita', sortable: false },
    { label: 'Codice fiscale', sortable: true, sortingField: 'codiceFiscale' },
    { label: 'Ruolo', sortable: false },
    { label: 'Tessera', sortable: false },
    { label: 'Emissione tessera', sortable: false },
    { label: 'Scadenza tessera', sortable: false },
    { label: 'Matricola', sortable: false },
  ]

  if (admin) columns = [...columns, { label: 'Società', sortable: false }]

  const [openCarica, setOpenCarica] = useState()
  const handleClickOpenCarica = () => setOpenCarica(true)
  const handleCloseCarica = () => setOpenCarica()

  return (
    <Grid container paddingX={2} spacing={2} sx={{ width: '100%' }}>
      <GridHeader h2 text='Tesserati' />
      <Grid container alignItems='center' sx={{ width: '100%' }}>
        <SelectionBar yStagione ySocieta={admin} yTessera />
        {admin && config?.features?.tesserati && (
          <>
            <Grid size={{ xs: 6, md: 2 }}>
              <center>
                <Button light onClick={handleClickOpenCarica}>
                  Carica Tesserati
                </Button>
                <DialogUploadTesserati
                  open={openCarica}
                  handleClose={handleCloseCarica}
                />
              </center>
            </Grid>
            <Grid size={{ xs: 6, md: 2 }}>
              <ButtonDownload algorithm='19_UpdateTesserati' type='TXT' />
            </Grid>
          </>
        )}
      </Grid>
      {(isFetching && <GridCircularProgress />) ||
        (!tesseratiN && (
          <GridHeader text='Elenco dei tesserati non trovato.' />
        )) ||
        (!tesseratiN?.length && (
          <GridHeader text='Nessun tesserato trovato.' />
        )) || (
          <Grid container paddingY={2} sx={{ width: '100%' }}>
            <TableContainer component={Paper}>
              <Table size='small'>
                <SortableTableHead
                  table={tesseratiN}
                  columns={columns}
                  tableName='tesserati'
                />
                <TableBody>
                  {tesseratiN?.map((i, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor: colours.white,
                          ':hover': { backgroundColor: colours.greyVeryLight },
                        }}
                      >
                        <TableCellSesso sesso={i?.sesso} />
                        <TableCell>{`${i.cognomenome}`}</TableCell>
                        <TableCell>{i.dataNascita}</TableCell>
                        <TableCell>{i.codiceFiscale}</TableCell>
                        <TableCellRuolo ruolo={i.ruolo} />
                        <TableCell>{i.tesseraPGS}</TableCell>
                        <TableCell>{i.emissioneTessera}</TableCell>
                        <TableCell>{i.scadenzaTessera}</TableCell>
                        <TableCell>{i.matricolaPGS}</TableCell>
                        {admin && <TableCell>{i.codiceSocieta}</TableCell>}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
    </Grid>
  )
}

export default Tesserati
